import { useEffect } from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import UserManagementActions from "../../Actions/UserManagementActions";
import { useLanguageContext } from "../../Context/LanguageContext";
import OrganisationSettingActions from "../../Actions/OrganisationSettingActions";
import organisationSettingConstants from "../../Constants/OrganisationSettingConstants";
import organisationSettingStore from "../../Stores/OrganisationSettingStore";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import Validate from "../ControlValidation/Validate";
import AppConstants from "../../Constants/AppConstants";

const AddOrganizations = (props) => {
  const location = useLocation();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [orgid, setOrgId] = useState(
    location && location.state
      ? location.state.orgid
      : AppConstants.DEFAULT_GUID,
  );
  const [organisationName, setOrganizationname] = useState(
    location && location.state ? location.state.orgname : "",
  );
  const [isblocked, setIsBlocked] = useState(
    location && location.state ? location.state.isblocked : false,
  );
  const { localization } = useLanguageContext();
  const [optionValue, setoptionValue] = useState({
    DateFormat: [],
    TimeZone: [],
  });
  const [ValidationError, setIsValidationError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const settingName = ["DateFormat", "TimeZone", "Language"];
  const selectDropDowm = [
    {
      label: "DateFormat",
      option: optionValue.DateFormat,
      translation: localization.dateFormat,
    },
    {
      label: "TimeZone",
      option: optionValue.TimeZone,
      translation: localization.timeZone,
    },
  ];

  const [orgDefaultSett, setOrgDefaultSett] = useState({
    TimeZone: "",
    subdomain: "",
    DateFormat: "",
  });

  useEffect(() => {
    OrganisationSettingActions.getOrganisationSettings();
  }, []);

  useEffect(() => {
    function getOrgSettingSuccess() {
      var res = organisationSettingStore.getOrgSettingResult();
      if (res.length > 0) {
        let previous = { ...optionValue };
        res.map((item, index) => {
          if (settingName.includes(item.settingName)) {
            previous[item.settingName] = res[index].options;
          }
        });
        setoptionValue(previous);
      }
      setGlobalSpinner(false);
    }
    function getOrgSettingFailure() {
      setGlobalSpinner(false);
    }

    organisationSettingStore.addChangeListener(
      organisationSettingConstants.GET_ORG_SETTING_SUCCESS,
      getOrgSettingSuccess,
    );

    organisationSettingStore.addChangeListener(
      organisationSettingConstants.GET_ORG_SETTING_FAILURE,
      getOrgSettingFailure,
    );

    return () => {
      organisationSettingStore.removeChangeListener(
        organisationSettingConstants.GET_ORG_SETTING_SUCCESS,
        getOrgSettingSuccess,
      );

      organisationSettingStore.removeChangeListener(
        organisationSettingConstants.GET_ORG_SETTING_FAILURE,
        getOrgSettingFailure,
      );
    };
  }, []);

  const addOrganisation = (e) => {
    e.preventDefault();
    var organisation = {
      ID: orgid,
      Name: organisationName,
      IsBlocked: isblocked,
      BlockingReason: "",
      DateFormat: orgDefaultSett.DateFormat,
      TimeZone: orgDefaultSett.TimeZone,
      SubDomain: orgDefaultSett.subdomain,
    };
    setGlobalSpinner(true);
    UserManagementActions.addOrUpdateOrganisation(organisation);
  };

  function handleOrgSetting(e) {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;
    if (name === "subdomain") {
      const error = Validate(value, ["Special_Char"]);
      if (error.length > 0) {
        setIsValidationError(true);

        const errorMsg =
          error[0].errorMsg === "characterNotallowed"
            ? [...error[0].character] + localization.characterNotallowed
            : localization.spaceNotallowed;
        setErrorMsg(errorMsg);
      } else {
        setIsValidationError(false);
        setErrorMsg("");
      }
    }
    const previous = { ...orgDefaultSett };
    previous[name] = value;
    setOrgDefaultSett(previous);
  }
  function handlePopoverClose(e) {
    e.preventDefault();
    setOrganizationname("");
    setOrgDefaultSett({
      TimeZone: "",
      subdomain: "",
      DateFormat: "",
    });
  }

  let renderMe = (
    <div
      className="modal fade"
      id="addOrganisationModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="addOrganisationModal"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addOrganisationModal">
              {localization.addOrganisationPopUpTitle}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="addOrganisationModalClose"
              onClick={(e) => {
                handlePopoverClose(e);
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form
            id="addOrganisation"
            autoComplete="off"
            onSubmit={addOrganisation}
          >
            <div className="modal-body">
              <div className="row mb-4">
                <div className="col">
                  <div className="form-outline">
                    <label className="form-label" htmlFor="organisationName">
                      {localization.organisation}
                    </label>
                    <input
                      type="text"
                      id="organisationName"
                      name="organisationName"
                      className="form-control"
                      placeholder={localization.organisationName}
                      required
                      value={organisationName}
                      onChange={(e) => {
                        setOrganizationname(e.target.value);
                      }}
                    />
                  </div>
                  {selectDropDowm.map((item, index) => {
                    return (
                      <div className="form-outline" key={index}>
                        <label className="form-label" htmlFor={item.label}>
                          {item.translation}
                        </label>

                        <select
                          className="form-control"
                          id={item.label}
                          name={item.label}
                          value={orgDefaultSett[item.label]}
                          required
                          onChange={(e) => {
                            handleOrgSetting(e);
                          }}
                        >
                          <option value="" disabled>
                            {localization.selectDefault} {item.translation}
                          </option>

                          {item.option.map((item, index) => {
                            return (
                              <option key={index} value={item.value}>
                                {item.text}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    );
                  })}
                  <div className="form-outline">
                    <label className="form-label" htmlFor="subdomain">
                      {localization.subDomain}
                    </label>
                    <input
                      type="text"
                      id="subdomain"
                      name="subdomain"
                      className={`form-control ${
                        ValidationError ? "is-invalid" : ""
                      }`}
                      placeholder={localization.subDomain}
                      required
                      value={orgDefaultSett.subdomain}
                      onChange={(e) => {
                        handleOrgSetting(e);
                      }}
                    />
                    {ValidationError && (
                      <div
                        id="validationServer03Feedback"
                        class="invalid-feedback"
                      >
                        {errorMsg}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="form-group marProp ">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-4"
                  disabled={ValidationError}
                >
                  {localization.save}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );

  return renderMe;
};

export default AddOrganizations;
